import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Button, Card, Col, Row, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import axiosInstance from "../services/axiosInterceptor";
import { getPosName } from "../services/authorize";
import userAvatar from "../assets/img/img1.jpg";

const GENDER_TH = { m: "ชาย", f: "หญิง" };

const UPLOAD_BASE = (process.env.REACT_APP_API || "http://localhost:3002/api")
  .replace(/\/api\/?$/, "")
  .replace(/\/$/, "");

const resolveUploadUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${UPLOAD_BASE}${path.startsWith("/") ? path : `/${path}`}`;
};

export default function ProfileView() {
  const [skin, setSkin] = useState(localStorage.getItem("skin-mode") ? "dark" : "");
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {}, [skin]);

  useEffect(() => {
    axiosInstance.get("/api/profile")
      .then((res) => setProfile(res.data))
      .catch((err) =>
        Swal.fire("ผิดพลาด", err.response?.data?.message || "โหลดข้อมูลไม่สำเร็จ", "error")
      )
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (d) => {
    if (!d) return "-";
    const [y, m, day] = d.split("-");
    return `${day}/${m}/${Number(y) + 543}`; // แสดงเป็น พ.ศ.
  };

  const rows = profile
    ? [
        { label: "รหัสประจำตัว / ชื่อผู้ใช้", value: profile.t_idnumber, icon: "ri-id-card-line" },
        { label: "ชื่อ - สกุล", value: profile.t_name, icon: "ri-user-line" },
        { label: "ชื่อภาษาอาหรับ / ยาวี", value: profile.t_arabicname || "-", icon: "ri-translate-2", rtl: true },
        { label: "เพศ", value: GENDER_TH[profile.t_gen] || "-", icon: "ri-men-line" },
        { label: "เบอร์โทรศัพท์", value: profile.t_phone || "-", icon: "ri-phone-line" },
        { label: "วันเกิด", value: formatDate(profile.t_birthdate), icon: "ri-cake-2-line" },
      ]
    : [];

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link to="#">บัญชีผู้ใช้</Link></li>
              <li className="breadcrumb-item active" aria-current="page">โปรไฟล์</li>
            </ol>
            <h4 className="main-title mb-0">โปรไฟล์ของฉัน</h4>
          </div>
        </div>

        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Card className="card-one">
              <Card.Body>
                {loading ? (
                  <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>
                ) : profile ? (
                  <>
                    <div className="d-flex flex-column align-items-center text-center mb-4">
                      <div className="avatar avatar-xl mb-3"><img src={resolveUploadUrl(profile.t_photo) || userAvatar} alt="avatar" /></div>
                      <h5 className="mb-1 fw-semibold">{profile.t_name}</h5>
                      <p className="fs-sm text-secondary mb-0">{getPosName()}</p>
                    </div>

                    <ul className="list-group list-group-flush">
                      {rows.map((r, i) => (
                        <li key={i} className="list-group-item d-flex align-items-center px-0">
                          <i className={`${r.icon} fs-18 text-primary me-3`}></i>
                          <span className="text-secondary" style={{ minWidth: 170 }}>{r.label}</span>
                          <span className="fw-medium ms-auto text-end" dir={r.rtl ? "rtl" : "ltr"}>{r.value}</span>
                        </li>
                      ))}
                    </ul>

                    <div className="d-grid mt-4">
                      <Button as={Link} to="/account/profile/edit" variant="primary">
                        <i className="ri-edit-2-line me-1"></i> แก้ไขโปรไฟล์
                      </Button>
                    </div>
                  </>
                ) : (
                  <div className="text-center text-secondary py-5">ไม่พบข้อมูลผู้ใช้</div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Footer />
      </div>
    </React.Fragment>
  );
}
